/** @flow */
import React from "react";
import classNames from "classnames";
import { Input } from "reactstrap";
import "./text-field.style.scss";

type TextFieldProps = $Exact<{
  ...Input,
  small?: boolean,
  format?: string,
}>;

const TextField = (props: TextFieldProps) => (
  <Input
    {...props}
    className={classNames(
      "text-field",
      {
        small: props.small,
      },
      props.className,
    )}
  />
);

export default TextField;
